const extractCurrentLocals = (i18nObj) => {
  const currentLocal = i18nObj?.locale;
  return i18nObj?.locales.find(locale => locale.code === currentLocal)
}
export default extractCurrentLocals;
